<template>
    <exportTemplate :table-data="tableList" :summary-data="tableSummaryData" :table-total="paginationTotal" :table-load="tableLoading" @set-custom-columns="setCustomColumns" @close-custom-columns="closeCustomColumns" @pagination-change="paginationChange" @form-submit="formSubmit" @sort="sortChange" ref="tabBox" @table-export="tableExport" :form-model="queryForm" @emitDblclick="emitDblclick">
        <template #form>
            <el-form-item label="当期范围" prop="billDate.selected">
                <date-picker class="query_form_item" style="width: 100%;" v-model="queryForm.billDate.selected" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
                </date-picker>
            </el-form-item>
            <el-form-item label="大片区" prop="domainDesc.selected">
                <select-multiple :select-data="queryForm.domainDesc" ref="domainDesc" :change="(val) => { domainSelect(val, 1) }"></select-multiple>
            </el-form-item>
            <el-form-item label="小片区" prop="smallDomain.selected">
                <select-multiple :select-data="queryForm.smallDomain" ref="smallDomain" :change="(val) => { domainSelect(val, 2) }"></select-multiple>
            </el-form-item>
            <el-form-item label="渠道" prop="classify.selected">
                <select-multiple :select-data="queryForm.classify"></select-multiple>
            </el-form-item>
            <el-form-item label="客户" prop="customer.selected">
                <select-multiple :select-data="queryForm.customer"></select-multiple>
            </el-form-item>
            <el-form-item prop="customerIDType.selected">
                <el-radio-group v-model="queryForm.customerIDType.selected">
                    <el-radio label="A">全部</el-radio>
                    <el-radio label="B">活跃客户</el-radio>
                    <el-radio style="margin-top: 18px;" label="C">未采购客户</el-radio>
                </el-radio-group>
            </el-form-item>
        </template>
        <template>
            <el-table-column :index="1" label="客户" prop="customerName" fixed></el-table-column>
            <el-table-column :index="2" label="渠道" prop="classifyName" width="120" v-if="customColumnList['classifyName']"></el-table-column>
            <el-table-column :index="3" label="大片区/小片区" prop="domainAll" width="120" v-if="customColumnList['domainAll']"></el-table-column>
            <el-table-column :index="4" label="助记码" prop="helpCode" width="100" v-if="customColumnList['helpCode']"></el-table-column>
            <el-table-column :index="5" label="客户采购金额" prop="salTotalAmt" width="120" sortable="custom"></el-table-column>
            <el-table-column :index="6" label="采购数量" prop="salQty" width="100"></el-table-column>
            <el-table-column :index="7" label="客户退货金额" prop="returnTotalAmt" width="120" sortable="custom"></el-table-column>
            <el-table-column :index="8" label="退货数量" prop="returnQty" width="100"></el-table-column>
            <el-table-column :index="9" label="净采购金额" prop="netSalTotalAmt" width="120" sortable="custom"></el-table-column>
        </template>
    </exportTemplate>
</template>
<script>
import exportTemplate from '@/components/common/exportTemplate.vue'
import datePicker from '@/components/common/datePicker.vue'
import { pickerOptions, getAddDate, getNowFormatDate, toRawType, toFixedRe, exportExcelCommonForVue } from '@/assets/js/common.js'
export default {
    name: 'SalemanMarket',
    props: ['customerIDType', 'beginDate', 'endDate'],
    components: {
        exportTemplate,
        datePicker
    },
    data() {
        let beginDate = getAddDate(-3)
        let endDate = getNowFormatDate()
        return {
            params: {
                page: 1,
                size: 20,
                customerIDType: 'A'
            },
            paginationTotal: 0,
            tableList: [],
            queryForm: {
                domainDesc: { submitName: 'domainID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择客户大片区', request: { url: '/Account/domainDefine/getDomainListForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                smallDomain: { submitName: 'smallDomainID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择客户小片区', request: { url: '/Account/domainDefine/getSmallDomainListNewForVue.html', type: 'post', params: { page: 1, size: 5, parentDomainID: '' }, text: '', value: '' } },
                customer: { submitName: 'customerID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择客户', request: { url: '/Account/customerDefine/getCustomerListForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                classify: { submitName: 'classifyID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择渠道', request: { url: '/Account/customerTypeDefine/getCustomerTypesForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                billDate: { submitName: 'billDate', selected: [beginDate, endDate] },
                customerIDType: { submitName: 'customerIDType', selected: 'A' }
            },
            pickerOptions: pickerOptions,
            tableSummaryData: {},
            tableLoading: false,
            // customColumnsList: [{
            //     label: "部门",
            //     prop: "departmentName"
            // }],
            customColumnsList: [{
                    label: "渠道",
                    prop: "classifyName"
                },
                {
                    label: "大片区/小片区",
                    prop: "domainAll",
                },
                {
                    label: "助记码",
                    prop: "helpCode",
                },
            ],
            customColumn: [],
            transmitQuery: {}
        }
    },
    created() {
        if (this.customerIDType) {
            this.queryForm.customerIDType.selected = this.customerIDType
        }
        if (this.beginDate && this.endDate) {
            this.queryForm.billDate.selected = [this.beginDate, this.endDate]
        }
        this.getTableList()
        this.getCustomColumnsList()
        this.transmitQuery = JSON.parse(JSON.stringify(this.queryForm))
    },
    computed: {
        queryItem() {
            let tempItem = {}
            Object.values(this.queryForm).forEach(item => {
                console.log(item)
                if (item.submitName == 'billDate') {
                    tempItem['beginDate'] = item.selected && item.selected.length > 0 ? item.selected[0] : ''
                    tempItem['endDate'] = item.selected && item.selected.length > 0 ? item.selected[1] : ''
                } else {
                    if (toRawType(item.selected) == 'Array') {
                        tempItem[item.submitName] = item.selected.map(i => "'" + i.value + "'").join(',') || ''
                    } else if (toRawType(item.selected) == 'String') {
                        tempItem[item.submitName] = item.selected || ''
                    }
                }
            })
            return tempItem
        },
        customColumnList() {
            let tempItem = {}
            this.customColumn.forEach(i => {
                tempItem[i.prop] = (i.isShow == 'Y')
            })
            console.log(tempItem)
            return tempItem
        }
    },
    methods: {
        setCustomColumns(el) {
            let tempArr = [...this.customColumn]
            el.loading = false
            el.setCustomcolumns(tempArr)
        },
        closeCustomColumns(el) {
            console.log(el)
            el.$nextTick(async () => {
                let { customColumns } = el
                const { data: res } = await this.$http.post('/Account/customerColumnDefineVue/saveColAndAuthByFuncCode.html', this.Qs.stringify({
                    funcCode: 224,
                    customSetInfo: JSON.stringify(customColumns)
                }))
                if (res.code != 'success') return this.$message.error(res.message)
                this.$message.success(res.message)
            })
            console.log(this.customColumn)
            this.$nextTick(() => {
                this.$refs["tabBox"].$refs["table"].doLayout()
            })
        },
        paginationChange({page, size, isGetTable = true}) {
            this.params.page = page
            this.params.size = size
            if (isGetTable) {
                this.getTableList()
            }
        },
        formSubmit(el) {
            this.transmitQuery = JSON.parse(JSON.stringify(this.queryForm))
            console.log(this.queryItem)
            this.getTableList()
        },
        async getTableList() {
            // this.tableList = [{ name: 'fdf' }]
            this.tableLoading = true
            console.log(this.tableLoading)
            this.tableData = []
            const { data: res } = await this.$post('/erpnew/account/c/reada46ceb/ShopMarket/selectShopCoverageList.html', { ...this.params, ...this.queryItem });
            this.tableLoading = false
            if (res.code != '0') return this.$message.error(res.message)
            let { data, sum, total } = res.data
            this.paginationTotal = total
            this.tableSummaryData = sum
            this.tableList = data
        },
        sortChange({ sortField, sortBy }) {
            this.params['sortField'] = sortField
            this.params['sortBy'] = sortBy
            this.params.page = 1
            this.getTableList()
        },
        async getCustomColumnsList() {
            const { data: res } = await this.$http.post(
                "Account/dataSearchVue/selectColumnByFuncCode.html",
                this.Qs.stringify({ funcCode: 224 })
            );
            if (res.code != "success")
                return this.$confirm(res.message, "提示", {
                    confirmButtonText: "确定",
                    showCancelButton: false,
                    type: "error",
                });
            let result = JSON.parse(res.result);
            let tempArr = [];
            let arr = [];
            this.customColumnsList.forEach((item) => {
                result.forEach(($item) => {
                    if (item.prop == $item.prop) {
                        arr.push({
                            id: $item.id,
                            label: item.label,
                            prop: item.prop,
                            isShow: $item.isShow,
                        });
                    }
                });
            });
            this.customColumn = [...arr]
            console.log(this.customColumn)
        },
        domainSelect(val, type) {
            let str = val.map(item => "'" + item.value + "'").join(',')
            let big = this.queryForm.domainDesc.selected.length > 0 ? this.queryForm.domainDesc.selected.map(item => "'" + item.value + "'").join(',') : ''
            let small = this.queryForm.smallDomain.selected.length > 0 ? this.queryForm.smallDomain.selected.map(item => "'" + item.value + "'").join(',') : ''
            if (type == 1) {
                this.queryForm.smallDomain.request.params.parentDomainID = str
                this.queryForm.smallDomain.isReSearch = true
            }
            this.queryForm.customer.request.params['domainID'] = big
            this.queryForm.customer.request.params['smallDomainID'] = small
            this.queryForm.customer.isReSearch = true
        },
        tableExport(arr) {
            exportExcelCommonForVue({
                ...this.params,
                ...this.queryItem
            }, arr, '/erpnew/account/c/reada46ceb/ShopMarket/selectShopCoverageListExport.html')
            console.log(arr)
        },
        emitDblclick(row) {
            if(!row.salQty && !row.returnQty) {
                this.$message({ message: '暂无数据', type: 'warning'})
                return
            }
            this.formSubmit()
            console.log(row)
            console.log(this.transmitQuery)
            for(let i in row) {
                Object.keys(this.transmitQuery).map((key) => {
                    if(row[i] && i === this.transmitQuery[key].submitName) {
                        // 需求#154：selected 为字符串的单选字段（customerLevel/customerStatus/productClassification 等）直接跳过，
                        // 避免被转成对象数组，导致销售明细表(新) 页面显示 [object Object]
                        if(!Array.isArray(this.transmitQuery[key].selected)) {
                            return
                        }
                        let arr = []
                        if(this.transmitQuery[key].selected.length) {
                            arr = this.transmitQuery[key].selected.filter(item => { return item.value === row[i] }) 
                        } else {
                            let str = i.replace('ID','Name')
                            let obj = { value: row[i], text: row[str] }
                            arr.push(obj)

                            if(i === 'itemID' || i === 'customerID') {
                                this.transmitQuery[key].list = arr
                            }
                        }
                        this.transmitQuery[key].selected = arr
                    }
                })
            }
            console.log(this.transmitQuery)
            let width = window.top.document.browser.availiframeWidth.value
            let height = window.top.document.browser.availiframeHeight.value
            let timestemp = new Date().getTime()
            this.transmitQuery.timestemp = timestemp
            top.addPanel('销售明细表(新)', `/templates/vue-account/dist/index.htm#/commodityDetails?type=1&timestemp=${timestemp}`, width, height, true, this.transmitQuery)
        }
    }
}
</script>
<style lang="less" scoped>
/deep/.table-item {
    padding: 0 !important;

    .cell {
        padding: 0 !important;
        text-align: center;
    }

    .item {

        p {
            line-height: 26px;
            flex: 1;
            text-align: center;

            &:last-child {
                border-top: 1px solid #ccc;
                color: #909399;
            }
        }
    }
}
</style>